export const MASTER_DATA_RESOURCES = [
  'investment-relationships',
  'investment-leads',
  'investment-projects',
  'investment-decisions',
  'investment-transactions',
  'investment-dashboard',
  'investment-fund-setup',
  'investment-fundraising',
  'investment-fund-operations',
  'fund-cash-call',
  'fund-payment',
  'fund-distribution',
  'portfolio-company',
  'portfolio-report',
  'exit-project',
  'exit-opportunity',
  'exit-transaction',
  'exit-dashboard',
  'research-topics',
  'research-companies',
  'research-materials',
  'research-viewpoints',
];
export function canUseMasterData(
  access: Record<string, unknown>,
  action: 'view' | 'create' | 'edit',
) {
  return Boolean(
    access.tenantAdmin ||
      (action === 'view' && access['investment-seals:view']) ||
      MASTER_DATA_RESOURCES.some(
        (resource) =>
          access[`${resource}:${action}`] || access[`${resource}:manage`],
      ),
  );
}
